<div class="overlay-content">
  <a href="javascript:void(0)" class="closebtnlogin" (click)="closeLoginWindow()">&times;</a>
  <div class="row" style="margin-left: 15px;margin-right: 15px;padding-top: 30px;">
    <div class="col-12">
      <div class="header-text" >
        <p *ngIf="!isLogin()">Sign Up To Poke The Villa Owners To Share Exclusive Discounts For Your Date Selection Within 24 Hours!</p>
        <p *ngIf="isLogin()">Log In To Poke The Villa Onwers To Share Exclusive Discounts For Your Date Selection Within 24 Hours!</p>
      </div>
    </div>
    <div *ngIf="isLogin() && !forgotPassword" class="col-12 login-form">
      <form (ngSubmit)="onInternalSubmit()">
        <input [(ngModel)]="user.email" class="form-control" placeholder="Enter Username" name="username" type="text" required>
        <div class="psswrd">
          <input [(ngModel)]="user.passwd" type="password" placeholder="Enter Password" name="password" class="form-control" required>
        </div>
        <input class="form-control loginbtn" type="submit" value="Log In" (click)="dismiss()">
      </form>
    </div>
    <div *ngIf="forgotPassword" class="col-12 login-form">
      <form (ngSubmit)="onForgotPassword()">
        <input [(ngModel)]="user.email" class="form-control" placeholder="Enter Username" name="username" type="text" required>
        <div class="psswrd">
          <input [(ngModel)]="user.passwd" type="password" placeholder="Enter Password" name="password" class="form-control" required>
          <input [(ngModel)]="confirmedNewPassword" type="password" placeholder="Retype New Password" name="confirmedpassword" class="form-control" required>
        </div>
        <input class="form-control loginbtn" type="submit" value="Change Password">
      </form>
    </div>
    <div *ngIf="!isLogin()" class="col-12 login-form">
      <form id="signupForm" (ngSubmit)="signUp()">
        <input [(ngModel)]="userSignup.email" class="form-control" type="text" placeholder="Email address"  name="email" required>
        <input [(ngModel)]="userSignup.passwd" class="form-control" type="password" placeholder="Password" name="password" required>
        <input [(ngModel)]="userSignup.confirmedPassword" class="form-control" type="password" placeholder="Confirm password" name="confirmedpassword" required>
        <div class="nameSurname clear">
          <input [(ngModel)]="userSignup.name" class="form-control" type="text" placeholder="Name" name="name" required>
          <input [(ngModel)]="userSignup.surname" class="form-control" type="text" placeholder="Surname" name="surname" required>
        </div>
        <input class="form-control loginbtn" type="submit" value="Sign up!">
      </form>
    </div>
    <div class="cantLogin clear">
      <a (click)="forgotPassword = true" style="cursor: pointer">Can't login?</a>
    </div>
    <div *ngIf="isLogin()" class="otherlogininfo col-md-12">
      <span class="lbl">OR</span><br>
      <span class="socialOpt">Log in with</span>
      <ul class="socialIcn">
        <li class="fcbk"><a (click)= "socialSignin('loginFacebook')"></a></li>
        <li class="ggpl"><a (click)= "socialSignin('loginGoogle')"></a></li>
      </ul>
      <button (click) = "showSignup()">Not a Vervendo member?  Sign up</button>
    </div>
    <div *ngIf="!isLogin()" class="otherlogininfo col-md-12">
      <span class="lbl">OR</span><br>
      <span class="socialOpt">Sign up with</span>
      <ul class="socialIcn">
        <li class="fcbk"><a (click)= "socialSignup('signupFacebook')"></a></li>
        <li class="ggpl"><a (click)= "socialSignup('signupGoogle')"></a></li>
      </ul>
      <button (click) = "showSignin()">Already a Vervendo member? Sign in</button>
    </div>
  </div>
</div>

